<script setup lang="ts">
import NumberFlow from "@number-flow/vue";
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

defineProps<{
  value: number;
  label: string;
}>();

const { data: user } = useUser();
</script>

<template>
  <div class="flex flex-col items-center gap-1 tracking-tight text-black">
    <NumberFlow
      :class="
        twMerge(
          'bg-galbani flex size-12 items-center justify-center rounded-md text-[28px] leading-none font-medium text-white lg:size-16 lg:text-[42px]',
          user?.current_mechanic === 'lactel' && 'bg-lactel-blue',
        )
      "
      :value="value"
    />

    {{ label }}
  </div>
</template>
